angular.module('leanlaw').controller('PaymentMatterCtrl', ['$q', '$scope', '$state', 'viewInvoiceService', '$window', '$stateParams', 'userService', 'alerts', 'matterManager', 'clientManager', 'leanLawApi', 'accountingService', function ($q, $scope, $state, viewInvoiceService, $window, $stateParams, userService, alerts, matterManager, clientManager, leanLawApi, accountingService) {
  $scope.balance = {
    loading: true
  };
  $scope.transactions = {
    loading: true
  };
  $scope.trust = {
    loading: true
  };
  $scope.sort = 'date';
  $scope.reverse = true;
  $scope.include = {
    payments: true,
    drafts: false,
    paid: true
  };
  $scope.open = open;
  $scope.viewInvoice = viewInvoice;
  $scope.sendInvoice = sendInvoice;
  $scope.showItem = function (item) {
    if (!$scope.include.drafts && item.type === 'Invoice' && !item.invoices[0].processed) return false;
    if (!$scope.include.payments && (item.type === 'Payment' || item.type === 'Credit')) return false;
    if (!$scope.include.paid && item.type === 'Invoice' && !item.balance) return false;
    return true;
  };
  activate();

  /////////////////////

  function activate() {
    if (!$stateParams.matterId && !$stateParams.clientId) {
      throw new Error("Need matter or client id plz");
    }
    const init = $stateParams.matterId ? initMatter() : initClient();
    $scope.loading = true;
    init.catch(err => {
      alerts.error(err);
      $state.go('^.summary');
    }).finally(() => {
      $scope.loading = false;
    });
    userService.me().then(me => {
      $scope.me = me;
    });
  }
  function initMatter() {
    return matterManager.get($stateParams.matterId).then(matter => {
      $scope.clientOrMatter = matter;
      $scope.matter = matter;
      $scope.loading = false;
      return loadStuff({
        matterId: matter.id
      }, matter);
    });
  }
  function initClient() {
    return clientManager.get($stateParams.clientId).then(client => {
      $scope.clientOrMatter = client;
      $scope.client = client;
      $scope.loading = false;
      $scope.showMatter = true;
      return loadStuff({
        clientId: client.id
      }, client);
    });
  }
  function open(item) {
    if (item === 'Invoice') {
      const url = `${$scope.me.configuration.quickbooks}/app/invoice?txnId=${item.accounting.id}`;
      $window.open(url, '_blank');
    } else {
      const url = `${$scope.me.configuration.quickbooks}/app/recvpayment?txnId=${item.accounting.id}`;
      $window.open(url, '_blank');
    }
  }
  function viewInvoice(invoice) {
    viewInvoiceService.viewInvoice(invoice, true);
  }
  function sendInvoice(invoice) {
    leanLawApi.processInvoice({
      id: invoice.id,
      body: {
        send: true
      }
    }).then(() => {
      alerts.success("The invoice was emailed to the client");
    }).catch(err => {
      alerts.error(err);
    });
  }
  function loadStuff(query, clientOrMatter) {
    const promises = [];
    if (!clientOrMatter.accounting) {
      return $q.resolve();
    }
    query.check = true;
    $scope.transactions = {
      loading: true
    };
    promises.push(leanLawApi.listInvoices(query).then(list => {
      $scope.transactions.items = $scope.transactions.items || [];
      $scope.transactions.loading = false;
      list.invoices.forEach(i => {
        $scope.transactions.items.push({
          date: i.invoiceDate,
          amount: i.totals.billedAmount ?? i.totals.amount,
          balance: i.processed ? i.state.balance : undefined,
          due: i.processed ? i.due : undefined,
          type: "Invoice",
          invoices: [i],
          accounting: i.accounting,
          overdue: i.state.overdue
        });
      });
    }));
    promises.push(leanLawApi.listPayments(query).then(list => {
      $scope.transactions.items = $scope.transactions.items || [];
      $scope.transactions.loading = false;
      list.payments.forEach(p => {
        $scope.transactions.items.push({
          date: p.date,
          amount: p.credits || p.amount,
          invoices: p.invoices.map(ip => ip.invoice),
          type: p.credits ? "Credit" : "Payment",
          accounting: p.accounting
        });
      });
    }));
    if (clientOrMatter.billing.trust) {
      promises.push(accountingService.getAccount(clientOrMatter.billing.trust.account.id).then(account => {
        $scope.trust = account;
      }));
    }
    const accountingId = clientOrMatter.accounting.id;
    promises.push(accountingService.getClient(accountingId).then(client => {
      $scope.balance = {
        amount: client.balance
      };
    }));
    return $q.all(promises);
  }
}]);